






















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeCpCompliance } from "@/store/modules/CpComplianceStore";
import CpComplianceSvc from "@/services/CpComplianceService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

const KOMPONEN_ORDER = ["terapi", "penunjang", "los", "tindakan", "diet", "edukasi"];
const KOMPONEN_LABELS: any = {
  terapi: "1. Terapi / Obat-obatan",
  penunjang: "2. Pemeriksaan Penunjang",
  los: "3. LOS",
  tindakan: "4. Tindakan / Prosedur",
  diet: "5. Diet / Nutrisi",
  edukasi: "6. Edukasi Pasien",
};

@Component
export default class CpComplianceDetail extends Vue {
  @Prop({ default: null }) sessionData!: any;

  storeModule = storeCpCompliance;
  session: any = null;
  showSignDialog = false;
  signPassword = "";
  signing = false;
  signRole: "ppa" | "ka_smf" | "komite" = "ppa";
  komponenLabels = KOMPONEN_LABELS;
  warningSnackbar = false;
  warningMessage = "";

  analisaPenyebabOptions: any = {
    kondisi_klinis_pasien_tidak_memungkinkan: "Kondisi klinis pasien tidak memungkinkan",
    permintaan_pasien_keluarga: "Permintaan pasien / keluarga",
    obat_alat_tidak_tersedia: "Obat / alat tidak tersedia",
    pasien_pulang_aps: "Pasien pulang atas permintaan sendiri (APS)",
    pasien_meninggal: "Pasien meninggal dalam perawatan",
    perubahan_diagnosis: "Perubahan diagnosis selama rawat inap",
    komorbiditas_mempengaruhi: "Komorbiditas yang mempengaruhi perjalanan klinis",
    lainnya: "Lainnya",
  };

  jenisVarianLabels: any = {
    klinis: "Klinis",
    manajerial: "Manajerial",
    sistem: "Sistem",
  };

  get signDialogTitle() {
    if (this.signRole === "ppa") return "Tanda Tangan PPA";
    if (this.signRole === "ka_smf") return "Tanda Tangan Kepala SMF / KSM";
    return "Persetujuan Komite Medik / Mutu";
  }

  get sortedItems() {
    if (!this.session || !this.session.items) return [];
    const items = [...this.session.items];
    return items.sort((a: any, b: any) =>
      KOMPONEN_ORDER.indexOf(a.komponen) - KOMPONEN_ORDER.indexOf(b.komponen)
    );
  }

  get cpLabel() {
    if (!this.session || !this.session.cp_definition) return "-";
    const d = this.session.cp_definition;
    return `${d.kode} - ${d.nama_pathway}`;
  }

  get diagnosisLabel() {
    if (!this.session) return "-";
    const k = this.session.diagnosis_icd10_kode || "";
    const u = this.session.diagnosis_icd10_uraian || "";
    return k || u ? `${k} - ${u}` : "-";
  }

  get jenisVarianLabel() {
    return this.session && this.session.jenis_varian
      ? this.jenisVarianLabels[this.session.jenis_varian] || this.session.jenis_varian
      : "-";
  }

  async mounted() {
    if (this.sessionData?.id) {
      await this.storeModule.loadDetail(this.sessionData.id);
      this.session = this.storeModule.currentSession;
    }
  }

  stripPrefix(label: string) {
    return label ? label.replace(/^\d+\.\s*/, "") : "";
  }

  formatDate(d: any) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  formatDatetime(d: any) {
    return d ? moment(d).format("DD-MM-YYYY HH:mm") : "-";
  }

  openSignDialog(role: "ppa" | "ka_smf" | "komite") {
    this.signRole = role;
    this.signPassword = "";
    this.showSignDialog = true;
  }

  showWarning(message: string) {
    this.warningMessage = message;
    this.warningSnackbar = true;
  }

  async doSign() {
    if (!this.signPassword) {
      this.showWarning("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      let resp;
      if (this.signRole === "ppa") {
        resp = await CpComplianceSvc.signPpa(this.session.id, { password: this.signPassword });
      } else if (this.signRole === "ka_smf") {
        resp = await CpComplianceSvc.signKaSmf(this.session.id, { password: this.signPassword });
      } else {
        resp = await CpComplianceSvc.signKomite(this.session.id, { password: this.signPassword });
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(resp.data.message || "Berhasil menandatangani");
        this.showSignDialog = false;
        this.signPassword = "";
        await this.storeModule.loadDetail(this.session.id);
        this.session = this.storeModule.currentSession;
        this.$emit("saved");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }

  printPdf() {
    if (this.session?.id) CpComplianceSvc.printPdf(this.session.id);
  }
}
